// Name corrections (?live=1): where the database's "known as" name is wrong or missing, the name
// to show instead. One line per player — full legal name (exactly as the database has it) on the
// left, the name to show on the right. Anyone can add one; it wins over the database.

export const NAME_CORRECTIONS: Readonly<Record<string, string>> = {
  // The database's nickname drops her surname ("Alessia Teresa").
  "Alessia Mia Teresa Russo": "Alessia Russo",
};
